'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';


export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#services', label: 'Diensten' },
    { href: '#avantages', label: 'Voordelen' },
    { href: '#zones', label: 'Zones' },
    { href: '#contact', label: 'Contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'scrolled py-3' : 'py-5'
      }`}
      style={{
        background: scrolled ? 'rgba(255,255,255,0.98)' : 'rgba(245,247,250,0.9)',
        backdropFilter: 'blur(12px)',
        borderBottom: scrolled ? '1px solid rgba(0,0,0,0.08)' : 'none',
      }}
    >
      <div className="max-w-7xl mx-auto px-5 flex items-center justify-between gap-4">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 shrink-0">
          <div className="h-10 w-auto">
            <img
              src="/assets/images/Group_5-1772290461625.png"
              alt="Hendrick Loodgieterij logo"
              className="h-10 w-auto object-contain"
            />
          </div>
        </a>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-8">
          {navLinks?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              className="nav-link text-sm font-medium transition-colors duration-200"
            >
              {link?.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="flex items-center gap-3">
          <a
            href="tel:+32496538283"
            className="hidden sm:flex items-center gap-2 text-sm font-semibold transition-all duration-300 px-4 py-2 rounded-full shine-sweep"
            style={{ background: '#16A34A', color: 'white' }}
          >
            <Icon name="PhoneIcon" size={15} className="text-white" />
            <span>0496 53 82 83</span>
          </a>
          <a
            href="https://wa.link/kusumk"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:flex items-center gap-2 text-sm font-semibold transition-all duration-300 px-4 py-2 rounded-full"
            style={{ background: 'rgba(34,197,94,0.12)', color: '#16A34A', border: '1px solid rgba(34,197,94,0.25)' }}
          >
            <Icon name="ChatBubbleLeftRightIcon" size={15} style={{ color: '#16A34A' }} />
            <span>WhatsApp</span>
          </a>
          {/* Mobile menu toggle */}
          <button
            className="lg:hidden p-2 rounded-lg"
            style={{ color: '#4A6580' }}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <Icon name={menuOpen ? 'XMarkIcon' : 'Bars3Icon'} size={22} />
          </button>
        </div>
      </div>
      {/* Mobile Menu */}
      {menuOpen && (
        <div
          className="lg:hidden absolute top-full left-0 w-full py-4 px-5"
          style={{ background: 'rgba(255,255,255,0.98)', borderTop: '1px solid rgba(0,0,0,0.08)' }}
        >
          {navLinks?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              className="block py-3 text-sm font-medium border-b"
              style={{ color: '#4A6580', borderColor: 'rgba(0,0,0,0.06)' }}
              onClick={() => setMenuOpen(false)}
            >
              {link?.label}
            </a>
          ))}
          <a
            href="tel:+32496538283"
            className="mt-4 flex items-center justify-center gap-2 py-3 rounded-xl font-semibold text-sm"
            style={{ background: '#16A34A', color: 'white' }}
          >
            <Icon name="PhoneIcon" size={16} />
            0496 53 82 83
          </a>
          <a
            href="https://wa.link/kusumk"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 flex items-center justify-center gap-2 py-3 rounded-xl font-semibold text-sm"
            style={{ background: 'rgba(34,197,94,0.12)', color: '#16A34A', border: '1px solid rgba(34,197,94,0.25)' }}
          >
            <Icon name="ChatBubbleLeftRightIcon" size={16} />
            WhatsApp
          </a>
        </div>
      )}
    </nav>
  );
}